document.addEventListener('DOMContentLoaded', () => {
  if (!window.Shopify) window.Shopify = {};

  function loadRecommendations(container) {
    const productId = container.dataset.productId;
    const sectionId = container.dataset.sectionId;
    const limit = container.dataset.limit || 8;
    const intent = container.dataset.intent || 'related';
    if (!productId || !sectionId) return;

    const root = window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    const url = `${root}recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`;

    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(container);

      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then((html) => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const newGrid = parsed.querySelector('[data-carousel-track]:not(.product-grid--fallback)');
          const currentGrid = container.querySelector('[data-carousel-track]:not(.product-grid--fallback)');
          const fallbackGrid = container.querySelector('[data-carousel-track].product-grid--fallback');

          if (newGrid && newGrid.children.length > 0) {
            if (currentGrid) {
              currentGrid.replaceWith(newGrid);
            }
            container.classList.remove('is-fallback-visible');
          } else if (fallbackGrid && fallbackGrid.children.length > 0) {
            container.classList.add('is-fallback-visible');
          } else {
            container.hidden = true;
          }

          window.dispatchEvent(new CustomEvent('product-carousel:updated', { detail: { section: container } }));
        })
        .catch(() => {
          const fallbackGrid = container.querySelector('[data-carousel-track].product-grid--fallback');
          if (fallbackGrid && fallbackGrid.children.length > 0) {
            container.classList.add('is-fallback-visible');
            window.dispatchEvent(new CustomEvent('product-carousel:updated', { detail: { section: container } }));
          } else {
            container.hidden = true;
          }
        });
    }, { rootMargin: '0px 0px 200px 0px' });

    observer.observe(container);
  }

  document.querySelectorAll('[data-recommendations]').forEach(loadRecommendations);
});
